import React from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import { base_url } from "../pages/Constants";

const TestimonialOne = () => {
  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return <FaArrowLeft className={className} onClick={onClick} />;
  }
  function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return <FaArrowRight className={className} onClick={onClick} />;
  }
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };
  const data =  useSelector((state)=>state.homePage.data);
  return (
    
    <>
      {/* testimonial area start */}
      {data&&(
          <div className='testimonial-area pd-top-115 pd-bottom-120'>
          <div className='container'>
            <div className='row justify-content-center'>
              <div className='col-lg-6'>
                <div className='section-title text-center mb-0'>
                  <h4 className='subtitle'>{data.page8.sub_title}</h4>
                  <h2 className='title'>{data.page8.name}</h2>
                  <p className='content'>
                    {data.page8.text}
                  </p>
                </div>
              </div>
            </div>
            <div className='testimonial-slider owl-carousel'>
              <Slider {...settings}>
                {data.page8.items.map(item=>(
                    <div className='item'>
                      <div className='single-testimonial-wrap'>
                        <div className='icon'>
                          <img
                            src='/assets/img/testimonial/quote.png'
                            alt=''
                          />
                        </div>
                        <p>
                          {item.text}
                        </p>
                        <div className='client-wrap'>
                          <div className='thumb'>
                            <img src={base_url+'/'+item.image} alt={item.name} />
                          </div>
                          <div className='details'>
                            <h5>{item.name}</h5>
                            <p>{item.sub_title}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                ))}
                
                
              </Slider>
            </div>
          </div>
        </div>
      )}
      
      {/* testimonial area end */}
    </>
  );
};

export default TestimonialOne;
